import { css } from '@emotion/css';
import { PR30, PR50 } from '@julofinance/color-token';
import BgVerified from './assets/bg-verified.png';

export const appliedPromoCx = css`
  background-image: url(${BgVerified});
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 8px;
  border: 1px solid ${PR30};
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${PR50};

  .btn-close {
    cursor: pointer;
  }

  .left-side {
    display: flex;
    align-items: center;

    & > div {
      margin-left: 12px;
    }
  }
`;
